const actionType = {
    GET_DEFINED_EVENTS: "GET_DEFINED_EVENTS",
    GET_EVENTS_PERMISSION: "GET_EVENTS_PERMISSION",
    GET_EVENTS_PERMISSION_GROUPS: "GET_EVENTS_PERMISSION_GROUPS",
    GET_EVENTS_PLACES: "GET_EVENTS_PLACES",
};

export default actionType;
